import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Header } from "../../../components/header/Header";
import { SketchDetails } from "../../../components/sketch_details/SketchDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  getRequestDetailThunk as onGetRequestDetailThunk,
  acceptRejectUserRequestThunk as onAcceptRejectUserRequestThunk,
  resetRequestThunk as onResetRequestThunk,
} from "../../../slices/user-requests/thunk";

import { Spinner } from "../../../components/spinner/Spinner";
import { createSelector } from "@reduxjs/toolkit";

export const RequestDetail = () => {
  
  const dispatch = useDispatch();
  const { requestId } = useParams();

  const [showLoader, setShowLoader] = useState(false);
  const [requestStatus, setRequestStatus] = useState(null);

  // Selector
  const selectRequestState = (state) => state.userRequest;
  const userRequestSelector = createSelector(selectRequestState, (user) => ({
    isLoading: user.isLoading,
    requestDetail: user.requestDetail,
    isSuccess: user.isSuccess,
  }));

  const { requestDetail, isLoading } = useSelector(userRequestSelector);

  const [sketchData, setSketchData] = useState({
    id: null,
    name: "",
    description: "",
    media: [],
  });

  const getRequestDetail=()=>{
 dispatch(onGetRequestDetailThunk({ requestId }));
  }

  // Fetch detail on mount
  useEffect(() => {
    if (requestId) {
     getRequestDetail()
    }
  }, [requestId]);

  // Update local state when requestDetail changes
  useEffect(() => {
    if (requestDetail) {
      setSketchData({
        id: requestDetail.id || null,
        name: requestDetail.contestCategory || "",
        description: requestDetail.contestDescription || "",
        media: requestDetail.contestMedia || [],
      });
      setRequestStatus(requestDetail.is_accept);
    }
  }, [requestDetail]);

  // Handle Accept
  const handleAcceptRequest = async () => {
    setShowLoader(true);
    await dispatch(onResetRequestThunk());
    await dispatch(onAcceptRejectUserRequestThunk({ id: requestId, is_accept: 1 }));
     getRequestDetail()
    setShowLoader(false);
  };

  // Handle Reject
  const handleRejectRequest = async () => {
    setShowLoader(true);
    await dispatch(onAcceptRejectUserRequestThunk({ id: requestId, is_accept: 2 }));
     getRequestDetail()
    setShowLoader(false);
  };

  return (
    <>
      {/* Header */}
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color">
        <Header title="Contest" showBack={true} />
      </header>

      <div className="w-full bg-[#F7F7F7] pt-4 sm:pt-0  pb-10">
        <div className="w-full mx-auto flex flex-col items-start justify-center gap-12 lg:flex-row">
          {/* Left Side */}
          <div className="w-full lg:w-[40%] flex">
            <SketchDetails
              name={sketchData.name}
              description={sketchData.description}
              sketchMedia={sketchData.media}
              isShowDetail={0}
             sketchData={sketchData}
             


            />
          </div>

          {/* Right Side */}
          <div className="w-full lg:w-[60%] flex flex-col items-center justify-start  sm:px-0">
            <div className="w-full border border-border_color rounded-[14px] flex flex-col p-3 sm:p-4 items-center bg-white">
              <p className="w-full min-h-[150px] p-3 rounded-xl text-sm text-gray-700">
                {sketchData.description || "No description available."}
              </p>
            </div>

            {/* Buttons Section */}
            <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-4 mt-10 sm:mt-24">
              {requestStatus == 3 && (
                <>
                  <button
                    onClick={handleRejectRequest}
                    disabled={showLoader}
                    className="w-full h-[52px] text-white bg-secondary tracking-wider font-grotesk text-sm font-bold py-[15px] px-4 rounded-[10px] whitespace-nowrap disabled:opacity-70"
                  >
                    {showLoader ? <Spinner /> : "Reject"}
                  </button>
                  <button
                    onClick={handleAcceptRequest}
                    disabled={showLoader}
                    className="w-full h-[52px] text-white bg-primary tracking-wider font-grotesk text-sm font-bold py-[15px] px-4 rounded-[10px] whitespace-nowrap disabled:opacity-70"
                  >
                    {showLoader ? <Spinner /> : "Accept"}
                  </button>
                </>
              )}

              {requestStatus == 1 && (
                <button
                  disabled
                  className="w-full h-[52px] text-white bg-primary tracking-wider font-grotesk text-sm font-bold py-[15px] px-4 rounded-[10px] whitespace-nowrap cursor-not-allowed"
                >
                  Accepted
                </button>
              )}

              {requestStatus == 2 && (
                <button
                  disabled
                  className="w-full h-[52px] text-white bg-secondary tracking-wider font-grotesk text-sm font-bold py-[15px] px-4 rounded-[10px] whitespace-nowrap cursor-not-allowed"
                >
                  Rejected
                </button>
              )}
            </div>

            {/* Global Loader */}
            {isLoading && (
              <div className="mt-8 flex justify-center items-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
